import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Nav from '../../components/Nav';
import Toast from '../../components/Toast';
import { AuthErrorBanner } from '../../components/AuthErrorBanner';
import '../../components/AuthErrorBanner.css';

export default function AppLayout({ userId, user, refreshMe }) {
  const location = useLocation();
  // Bottom nav stays visible at all times — the Profile/menu is reached
  // via the hamburger in the per-page header, and the Profile page itself
  // exposes a back arrow to return to the previous tab.
  return (
    <div className="hx-app" data-testid="app-container">
      <AuthErrorBanner variant="inline" />
      <main className="hx-app-content">
        <div key={location.pathname} className="page-fade-in">
          <Outlet context={{ userId, user, refreshMe }} />
        </div>
      </main>
      <Nav />
      <Toast />
    </div>
  );
}
